import React, { useState } from "react";
import styles from "./CashierStores.module.scss";
import { motion } from "framer-motion";
import Icon from "../../../../assets/icons";
import Images from "../../../../assets/images";
import primaryComponents from "../../../../components/primaryComponents";
import secondaryComponents from "../../../../components/secondaryComponents";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { useSelector } from "react-redux";
import { logoutHandler } from "../../../../helpers";
import CartCashierIcon from "../../../../assets/svgIcons/CartCashierIcon";
import Logo from "../../../../assets/logo";
import { Link } from "react-router-dom";
import { pathConstants } from "../../../../routes/pathContants";

const CashierStores = () => {
  const [storeIcons] = useState([
    Icon.storeIcon1,
    Icon.storeIcon2,
    Icon.storeIcon3,
  ]);
  const cashierDetail = useSelector(
    (state) => state.profileDetailsReducer.profileDetails,
  );
  const { storeList } = useSelector((state) => state.profileDetailsReducer);

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Cashier Dashboard"
      description="View all stores"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: { duration: 0.3 },
          }}
          exit={{ opacity: 0 }}
          className={`${styles.allStores} ${globalStyles.pageColumnGaps}`}
        >
          <div className={styles.dashboard_wrapper}>
            <div className={`${styles.dashboard_header}`}>
              {/* <strong className="default-text-size ml-5">Lumi Sell Mode</strong> */}
              <Link to={pathConstants.DASHBOARD_MAIN} className="ml-5">
                <img
                  width={48}
                  height={16}
                  src={Logo.lumiWhiteLogo}
                  alt="Lumi"
                />
              </Link>
              <div
                className={`${styles.dashboard_small} mr-5 d-flex justify-content-between align-items-center`}
                style={{ gap: "20px" }}
              >
                <strong className="green--text small-text-size">
                  {cashierDetail?.business_list[0]?.name}
                </strong>
                <div
                  style={{
                    backgroundColor: "#ddd",
                    height: "45px",
                    width: "2px",
                    opacity: "0.5",
                    paddingTop: "-20px",
                  }}
                ></div>
                <p
                  className="error--text small-text-size"
                  onClick={logoutHandler}
                  style={{ cursor: "pointer" }}
                >
                  ← | Log out
                </p>
              </div>
            </div>

            <div className={styles.dashboard_content}>
              <h4>
                Welcome,{" "}
                {cashierDetail
                  ? cashierDetail?.first_name + " " + cashierDetail?.last_name
                  : ""}
              </h4>
              <p
                className="d-flex justify-content-center align-items-center"
                style={{ gap: "10px" }}
              >
                <span className="small-text-size dark--text">
                  Start Selling
                </span>{" "}
                <CartCashierIcon />{" "}
                <span className="small-text-size dark--text">
                  by selecting a store below
                </span>
              </p>

              <div
                className={`${globalStyles.cardWithBorder} ${styles.cardWithBorder}`}
              >
                <div className="d-flex justify-content-start">
                  <h5>{storeList?.length} Stores</h5>
                </div>
                {storeList?.length > 0 ? (
                  <div className={styles.storeList}>
                    {storeList?.map((store, index) => (
                      <div className={styles.storeList__item} key={store?.id}>
                        <img src={storeIcons[index % 3]} alt="store icon" />
                        <h4 className="font-weight-normal">{store.name}</h4>
                        <primaryComponents.Button
                          classNames="btn btn--outline cover"
                          onClick={() =>
                            window.open(`/sell-mode/${store?.id}`, "_blank")
                          }
                        >
                          View Store
                        </primaryComponents.Button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center mt-5">
                    <img
                      width="250px"
                      height="262px"
                      src={Images.storeProductEmpty}
                      alt="empty state"
                    />
                    <h4>You haven&apos;t created a store yet </h4>
                    <p>When you do, they would appear here.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default CashierStores;
